import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import WelcomeCard from './WelcomeCard';
import { colataPermessi } from '../../../lib/services/colataService';

const HomeInventoryContent = () => {
  const navigate = useNavigate();
  // CCO: cco-admin, gru-admin e Owner vanno al nuovo inventario Colata, gli altri al vecchio CCO
  const [accessoColata, setAccessoColata] = useState(false);
  useEffect(() => {
    let annullato = false;
    colataPermessi()
      .then((p) => { if (!annullato) setAccessoColata(Boolean(p?.leggere)); })
      .catch(() => { /* in caso di errore resta /cco-home */ });
    return () => { annullato = true; };
  }, []);

  const mainCategories = [
    {
      id: 'cco',
      title: 'CCO',
      subtitle: 'Colata Continua',
      path: accessoColata ? '/colata-inventory' : '/cco-home',
      icon: 'Layers',
      color: 'from-orange-500 to-orange-600',
      glow: 'group-hover:shadow-orange-500/20',
      description: 'Gestione cilindri, paniera e componenti di colata.'
    },
    {
      id: 'gru',
      title: 'GRU',
      subtitle: 'Carriponte',
      path: '/gru-inventory',
      icon: 'GanttChart',
      color: 'from-blue-500 to-blue-700',
      glow: 'group-hover:shadow-blue-500/20',
      description: 'Controllo funi, paranchi e sistemi di sollevamento.'
    },
    {
      id: 'gaf',
      title: 'EAF',
      subtitle: 'Reparto Forno',
      path: '/eaf-inventory',
      icon: 'Flame',
      color: 'from-red-500 to-red-700',
      glow: 'group-hover:shadow-red-500/20',
      description: 'Monitoraggio elettrodi e refrattari forno elettrico.'
    }
  ];

  return (
    <div className="w-full animate-in fade-in slide-in-from-bottom-6 duration-1000 ease-out space-y-12 lg:space-y-20">
      
      {/* NOVI UNIFICIRANI HERO SECTION */}
      <WelcomeCard />

      {/* GRID SISTEM KATEGORIJA */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10">
        {mainCategories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => navigate(cat.path)}
            className={`group relative flex flex-col bg-card rounded-[2.5rem] border border-border/40 overflow-hidden transition-all duration-500 text-left hover:border-primary/40 hover:-translate-y-2 hover:shadow-[0_30px_60px_-15px_rgba(0,0,0,0.3)] ${cat.glow}`}
          >
            {/* Dekorativni gradijent vrh */}
            <div className={`h-2 w-full bg-gradient-to-r ${cat.color} opacity-80 group-hover:opacity-100 transition-opacity`} />
            
            <div className="p-8 lg:p-10 flex flex-col h-full">
              {/* IKONA I STRIJELICA */}
              <div className="flex justify-between items-start mb-12">
                <div className={`w-16 h-16 rounded-[1.5rem] bg-gradient-to-br ${cat.color} flex items-center justify-center text-white shadow-2xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 ease-spring`}>
                  <Icon name={cat.icon} size={32} strokeWidth={2.5} />
                </div>
                
                <div className="w-12 h-12 rounded-2xl bg-muted/50 backdrop-blur-sm border border-white/5 flex items-center justify-center group-hover:bg-primary group-hover:text-white group-hover:rotate-45 transition-all duration-500">
                  <Icon name="ArrowUpRight" size={20} strokeWidth={3} />
                </div>
              </div>

              {/* TEKSTUALNI SADRŽAJ */}
              <div className="flex-grow">
                <h3 className="text-4xl font-black tracking-tighter text-foreground mb-1 group-hover:translate-x-1 transition-transform duration-300">
                  {cat.title}
                </h3>
                <h4 className="text-[11px] font-black uppercase tracking-[0.25em] text-primary/70 mb-4">
                  {cat.subtitle}
                </h4>
                <p className="text-sm text-muted-foreground leading-relaxed font-medium opacity-70 group-hover:opacity-100 transition-opacity">
                  {cat.description}
                </p>
              </div>

              {/* DONJI ACTION BAR */}
              <div className="mt-10 flex items-center justify-between overflow-hidden">
                <div className="flex items-center gap-3">
                  <div className="w-6 h-[1px] bg-primary/30 group-hover:w-10 group-hover:bg-primary transition-all duration-500" />
                  <span className="text-[10px] font-black uppercase tracking-widest text-muted-foreground group-hover:text-primary transition-colors">
                    Visualizza Registro
                  </span>
                </div>
                <div className={`w-1.5 h-1.5 rounded-full bg-gradient-to-r ${cat.color} animate-pulse shadow-[0_0_10px_rgba(0,0,0,0.5)]`} />
              </div>
            </div>

            {/* Pozadinski dekorativni krugovi */}
            <div className={`absolute -bottom-16 -right-16 w-48 h-48 bg-gradient-to-br ${cat.color} opacity-[0.02] rounded-full blur-3xl group-hover:opacity-[0.1] group-hover:scale-150 transition-all duration-1000`} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default HomeInventoryContent;